import { HiDocumentText } from 'react-icons/hi';
import { ReportingContainerBaseConfig, ReportingControllerBaseConfig } from '../../base';
import { MentionPreviewController } from './mentionPreviewInterface';
import {
    MentionPreviewContentProps,
    MentionPreviewViewProps,
} from './mentionPreviewProps';
import { TextBlock } from '@varos/research-sdk-api';
import { MentionPreviewAggregate } from './mentionPreviewModel';

export function createMentionPreviewController(
    config: ReportingControllerBaseConfig
): MentionPreviewController {
    function getContentProps(item: MentionPreviewAggregate): MentionPreviewContentProps {
        if (item.block.status === 'loading') {
            return {
                isLoading: true,
                data: null,
            };
        }
        const [firstTextBlock, ...rest] = item.block.data.flatMap((block) =>
            block.data.kind === 'text' ? [block.data] : []
        );
        return {
            isLoading: false,
            description: firstTextBlock
                ? firstTextBlock.items
                      .flatMap((item) => {
                          if (item.kind === 'text') {
                              return [item.text];
                          }
                          return [];
                      })
                      .join(' ')
                : null,
        };
    }
    return {
        useProps(context, item, props): MentionPreviewViewProps {
            if (item.content.status === 'loading') {
                return {
                    status: 'loading',
                };
            }
            return {
                status: 'success',
                title: item.content.data.title ?? 'Untitled',
                block: getContentProps(item),
                icon: item.content.data.icon
                    ? {
                          kind: 'emoji',
                          text: item.content.data.icon,
                      }
                    : {
                          kind: 'icon',
                          Component: HiDocumentText,
                      },
                breadcrumb: item.content.parent
                    ? {
                          items: [
                              {
                                  id: 'workspace',
                                  label: 'Workspace',
                              },
                              {
                                  id: 'parent',
                                  label: item.content.parent.title ?? 'Untitled',
                              },
                          ],
                      }
                    : null,
            };
        },
    };
}
